const state = {
    personId: '',
    letterId: '',
    detail: {},
    isReply: {},
    letterStatus: '',
    files: [],
    entrustDepTree: [],
    handoverDepTree: [],
    superviseDepTree: [],
    superviseList: [],
    filesInReply: [],
    contentType: [],
    paramsDef: {
        pageNum: 1,
        pageSize: 30,
        sortMap: {},
        params: {
            isEffective: 1
        }
    },
    letterContent: '',
    sensitiveContent: {},
    sensitiveDialog: false,
    checkTypeParams: {},
    letterContentParams: {},
    citeReplyContent: '',
    uploadFile: {},
    alreadyChooseContentType: '',
    tabReplyParams: {},
    tabEntrustReplyParams: {},
    tabHandoverReplyParams: {},
    tabReplyEditContentParams: {},
    tabReleaseParams: {},
    tabSeeParams: {},
    tabHandleParams: {},
    tabSuperviseParams: {},
    tabAuditDelayList: [],
    auditPassParams: {},
    tabReturnList: [],
    tabOperationList: [],
    tabAuditApplyParams: {},
    pageFrom: '',
    tabBackParams: {},
    uploadAgainParams: {},
    letterTitleParams: {},
    letterTypeParams: {}
}

const actions = {
    // 信件详情
    async getDetail({ state, commit }) {
        const res = await GetMails({
            operateId: state.personId,
            operateType: "HANDLE"
        });
        if (res.status == "success") {
            if (res.data.errorCode == "403") window.location.href = res.data.casLoginUrl;
            commit('updateDetail', res.data);
        }
    },
    // 是否可操作
    async getIsReply({ state, commit }) {
        const res = await letterService.IsReply(state.personId);
        if (res.status == "success") {
            if (res.data.errorCode == "403") window.location.href = res.data.casLoginUrl;
            commit('updateIsReply', res.data);
        }
    },
    // 附件
    async getFiles({ state, commit }) {
        const res = await letterService.mailReplyFileFront({ id: state.detail.info.id });
        if (res.status == "success") {
            if (res.data.length <= 0) return;
            if (res.data.errorCode == "403") window.location.href = res.data.casLoginUrl;
            commit('updateFiles', res.data[0]);
        }
    },
    // 附件(回复)
    async getFilesInReply({ state, commit }) {
        const res = await letterService.mailReplyFile({ id: state.detail.info.id });
        if (res.status == "success") {
            if (res.data.length <= 0) return;
            if (res.data.errorCode == "403") window.location.href = res.data.casLoginUrl;
            commit('updateFilesInReply', res.data[0]);
        }
    },
    // 内容类别
    async getContentType({ commit }) {
        const res = await GetSelectContentListData();
        if (res.status == "success") {
            if (res.data.errorCode == "403") window.location.href = res.data.casLoginUrl;
            commit('updateContentType', res.data);
        }
    },
    // 获取(交办)部门树
    async getEntrustDepTree({ commit }) {
        const res = await jiaobanDeptTree(state.personId);
        if (res.status == "success") {
            if (res.data.errorCode == "403") window.location.href = res.data.casLoginUrl;
            commit('updateEntrustDepTree', res.data);
        }
    },
    // 获取(转办)部门树
    async getHandoverDepTree({ commit }) {
        const res = await zhuanbanDeptTree(state.personId);
        if (res.status == "success") {
            if (res.data.errorCode == "403") window.location.href = res.data.casLoginUrl;
            commit('updateHandoverDepTree', res.data);
        }
    },
    // 获取督办部门树
    async getSuperviseDepTree({ state, commit }) {
        const res = await dubanDeptTree(state.personId);
        if (res.status == "success") {
            if (res.data.errorCode == "403") window.location.href = res.data.casLoginUrl;
            commit('updateSuperviseDepTree', res.data);
        }
    },
    // 获取督办列表
    async getSuperviseList({ state, commit }) {
        const res = await listReminder(state.personId);
        if (res.status == "success") {
            if (res.data.errorCode == "403") window.location.href = res.data.casLoginUrl;
            commit('updateSuperviseList', res.data);
        }
    },
    // 设置来信人隐私
    async getPublic({ state }) {
        const res = await letterService.setShowFromInfo({ mailId: state.detail.info.id });
        if (res.status == 'success') {
            if (res.data.errorCode == "403") window.location.href = res.data.casLoginUrl;
            Message({
                message: res.data,
                type: res.status
            });
        }
    },
    // 确认修改信件内容
    async updateLetterContentAsync({ state }) {
        const res = await updateLetterContent(state.letterContentParams);
        Message({
            message: res.data,
            type: res.status
        });
        if (res.status == 'success') {
            if (res.data.errorCode == "403") window.location.href = res.data.casLoginUrl;
        }
    },
    // 确认修改信件标题
    async updateLetterTitleAsync({ state }) {
        const res = await updateLetterTitleName(state.letterTitleParams);
        Message({
            message: res.data,
            type: res.status
        });
        if (res.status == 'success') {
            if (res.data.errorCode == "403") window.location.href = res.data.casLoginUrl;
        }
    },
    // 敏感词检测
    async sensitiveCheckAsync({ state, commit }) {
        const res = await letterService.checkContent(state.checkTypeParams);
        if (res.status == 'success') {
            commit('updateSensitive', res.data);
        }
    },
    // 获取上传文件类型
    async getUploadFileType({ commit }) {
        const res = await replyMailFileLimit();
        if (res.status == 'success') {
            if (res.data.errorCode == "403") window.location.href = res.data.casLoginUrl;
            commit('updateUploadFileType', res.data[0].businessName);
        }
    },
    // 打印
    printLetter({ state }) {
        let url = `${baseUrl}/communication/api-common/file/expMailTempById?operateId=${state.personId}&operateType= `;
        window.location.href = url;
    },
    // tab回复--修改回复
    async getTabUpdateReply({ state }) {
        const res = await updateReply(state.tabReplyEditContentParams);
        Message({
            message: res.data,
            type: res.status
        });
        if (res.status == 'success') {
            if (res.data.errorCode == "403") window.location.href = res.data.casLoginUrl;
        }
    },
    // tab回复--提交
    async getTabAcceptReplySubmit({ state }) {
        const res = await letterService.SaveReply(state.tabReplyParams);
        Message({
            message: res.data,
            type: res.status
        });
        if (res.status == 'success') {
            if (res.data.errorCode == "403") window.location.href = res.data.casLoginUrl;
        }
    },
    // tab转办回复--提交
    async getTabHandoverReplySubmit({ state }) {
        const res = await handOver.saveDeptReply(state.tabHandoverReplyParams);
        Message({
            message: res.data,
            type: res.status
        });
        if (res.status == 'success') {
            if (res.data.errorCode == "403") window.location.href = res.data.casLoginUrl;
        }
    },
    // tab交办回复--提交
    async getTabEntrustReplySubmit({ state }) {
        const res = await entrust.delegateReply(state.tabEntrustReplyParams);
        Message({
            message: res.data,
            type: res.status
        });
        if (res.status == 'success') {
            if (res.data.errorCode == "403") window.location.href = res.data.casLoginUrl;
        }
    },
    // tab回复--发布
    async getTabReleaseSubmit({ state }) {
        const res = await letterService.publishMail(state.tabReleaseParams);
        Message({
            message: res.data,
            type: res.status
        });
        if (res.status == 'success') {
            if (res.data.errorCode == "403") window.location.href = res.data.casLoginUrl;
        }
    },
    // tab回复--参阅
    async getTabSeeSubmit({ state }) {
        const res = await letterService.mailReference(state.tabSeeParams);
        Message({
            message: res.data,
            type: res.status
        });
        if (res.status == 'success') {
            if (res.data.errorCode == "403") window.location.href = res.data.casLoginUrl;
        }
    },
    // tab交办--提交
    async getTabHandoverSubmit({ state }) {
        const res = await letterService.saveWbLetter(state.tabHandleParams);
        Message({
            message: res.data,
            type: res.status
        });
        if (res.status == 'success') {
            if (res.data.errorCode == "403") window.location.href = res.data.casLoginUrl;
        }
    },
    // tab转办--提交
    async getTabReferralSubmit({ state }) {
        const res = await letterService.saveAssignLetter(state.tabHandleParams);
        Message({
            message: res.data,
            type: res.status
        });
        if (res.status == 'success') {
            if (res.data.errorCode == "403") window.location.href = res.data.casLoginUrl;
        }
    },
    // tab督办--提交
    async getTabSuperviseSubmit({ state }) {
        const res = await letterService.UrgeMails(state.tabSuperviseParams);
        Message({
            message: res.data,
            type: res.status
        });
        if (res.status == 'success') {
            if (res.data.errorCode == "403") window.location.href = res.data.casLoginUrl;
        }
    },
    // tab获取延期审核列表
    async getTabAuditDelayList({ state, commit }) {
        const res = await letterService.getBackOrDelayLetterList2(state.personId);
        if (res.status == 'success') {
            if (res.data.errorCode == "403") window.location.href = res.data.casLoginUrl;
            commit('updateTabAuditDelayList', res.data);
        }
    },
    // tab延期审核列表(审核意见)
    async getTabAuditPass({ state }) {
        const res = await letterService.passTheLetter(state.auditPassParams);
        Message({
            message: res.data,
            type: res.status
        });
        if (res.status == 'success') {
            if (res.data.errorCode == "403") window.location.href = res.data.casLoginUrl;
        }
    },
    // tab获取退回列表
    async getTabReturnList({ state, commit }) {
        const res = await letterService.getReturnBackLetters(state.personId);
        if (res.status == 'success') {
            if (res.data.errorCode == "403") window.location.href = res.data.casLoginUrl;
            commit('updateTabReturnList', res.data);
        }
    },
    // tab获取退回操作
    async getTabBack({ state }) {
        const res = await handOver.backMail(state.tabBackParams);
        if (res.status == 'success') {
            if (res.data.errorCode == "403") window.location.href = res.data.casLoginUrl;
            Message({
                message: res.data,
                type: res.status
            });
        }
    },
    // tab获取操作列表
    async getTabOperationList({ state, commit }) {
        const res = await letterService.getLetterLogs(state.letterId);
        if (res.status == 'success') {
            if (res.data.errorCode == "403") window.location.href = res.data.casLoginUrl;
            commit('updateTabOperationList', res.data);
        }
    },
    // tab延期申请--提交(交办处理中展示)
    async getTabAuditApplySubmit({ state }) {
        const res = await handOver.delayApply(state.tabAuditApplyParams);
        Message({
            message: res.data,
            type: res.status
        });
        if (res.status == 'success') {
            if (res.data.errorCode == "403") window.location.href = res.data.casLoginUrl;
        }
    },
    // 办结完成后上传附件
    async uploadAgainAsync({ state }) {
        const res = await letterService.uploadAgain(state.uploadAgainParams);
        Message({
            message: res.data,
            type: res.status
        });
        if (res.status == 'success') {
            if (res.data.errorCode == "403") window.location.href = res.data.casLoginUrl;
        }
    },
    // 办结完成后上传附件
    async updateLetterTypeAsync({ state }) {
        const res = await updateObjectiveType(state.letterTypeParams);
        Message({
            message: res.data,
            type: res.status
        });
        if (res.status == 'success') {
            if (res.data.errorCode == "403") window.location.href = res.data.casLoginUrl;
        }
    },
    // 撤销 
    async backoutAsync ({ state }) {
        const { status, data } = await letterService.backout(state.personId)
        if (status === 'success') {
            Message({ message: '撤销成功', type: status })
        } else {
            Message({ message: data, type: 'error' })
        }
    }
}

const mutations = {
    updateOperateId: (state, payload) => state.personId = payload,
    updateLetterId: (state, payload) => state.letterId = payload,
    updateDetail: (state, payload) => state.detail = payload,
    updateIsReply: (state, payload) => state.isReply = payload,
    updateFiles: (state, payload) => {
        state.files = payload;
        state.files.download = `${baseUrl}/communication/api-common/file/download?path=${state.files.path}`;
    },
    updateFilesInReply: (state, payload) => {
        state.filesInReply = payload;
        state.filesInReply.download = `${baseUrl}/communication/api-common/file/download?path=${state.filesInReply.path}`;
    },
    updateEntrustDepTree: (state, payload) => state.entrustDepTree = payload,
    updateHandoverDepTree: (state, payload) => state.handoverDepTree = payload,
    updateSuperviseDepTree: (state, payload) => state.superviseDepTree = payload,
    updateSuperviseList: (state, payload) => state.superviseList = payload,
    updateContentType: (state, payload) => state.contentType = payload,
    updateLetterContentInfo: (state, payload) => {
        const { content } = payload;
        state.letterContentParams = { mailId: state.letterId, content };
    },
    updateSensitive: (state, payload) => state.sensitiveContent = payload,
    updateSensitiveDialog: (state, payload) => state.sensitiveDialog = payload,
    updateCheckType: (state, payload) => state.checkTypeParams = payload,
    updateCiteReplyContent: (state, payload) => state.citeReplyContent = payload,
    updateUploadFileType: (state, payload) => state.uploadFile = JSON.parse(payload),
    updateAlreadyChooseContentType: (state, payload) => state.alreadyChooseContentType = payload,
    updateTabReplyParams: (state, payload) => {
        const { replyContent, fileProperties } = payload;
        state.tabReplyParams = {
            id: state.personId,
            mailId: state.letterId,
            contentType: state.alreadyChooseContentType,
            replyContent,
            fileProperties
        }
    },
    updateTabEntrustReplyParams: (state, payload) => {
        const { replyContent, fileProperties } = payload;
        state.tabEntrustReplyParams = {
            operateId: state.personId,
            mailId: state.letterId,
            contentType: state.alreadyChooseContentType,
            replyContent,
            fileProperties
        }
    },
    updateTabHandoverReplyParams: (state, payload) => {
        const { replyContent } = payload;
        state.tabHandoverReplyParams = {
            replyContent,
            operateId: state.personId
        }
    },
    updateTabReplyEditContentParams: (state, payload) => {
        const { content, fileProperties } = payload;
        state.tabReplyEditContentParams = {
            operateId: state.personId,
            content,
            fileProperties
        };
    },
    updateTabReleaseParams: (state, payload) => {
        const { isPublish } = payload;
        state.tabReleaseParams = { mailId: state.letterId, isPublish };
    },
    updateTabSeeParams: (state, payload) => {
        const { isReference } = payload;
        state.tabSeeParams = { mailId: state.letterId, isReference };
    },
    updateTabHandleParams: (state, payload) => {
        const { deptIds, opinion } = payload;
        state.tabHandleParams = {
            operateId: state.personId,
            deptIds,
            contentType: state.alreadyChooseContentType,
            opinion
        }
    },
    updateTabSuperviseParams: (state, payload) => {
        const { deptId, reminderContent } = payload;
        state.tabSuperviseParams = {
            operateId: state.personId,
            deptId,
            reminderContent
        }
    },
    updateTabAuditDelayList: (state, payload) => state.tabAuditDelayList = payload,
    updateAuditPass: (state, payload) => {
        const { delayId, auditStatus, opinion } = payload;
        state.auditPassParams = { delayId, auditStatus, opinion }
    },
    updateTabReturnList: (state, payload) => state.tabReturnList = payload,
    updateTabOperationList: (state, payload) => state.tabOperationList = payload,
    updateTabAuditApplyParams: (state, payload) => {
        const { delayReason, delayDays } = payload;
        state.tabAuditApplyParams = {
            operateId: state.personId,
            delayReason,
            delayDays
        }
    },
    updatePageFrom: (state, payload) => state.pageFrom = `/communication/api-mailbox/mail/mail_handle/mail_handle_list?type=${payload.from}&pageNum=${payload.pageNum}&pageSize=${payload.pageSize}`,
    updateTabBackParams: (state, payload) => {
        const { backReason } = payload;
        state.tabBackParams = {
            operateId: state.personId,
            backReason
        }
    },
    updateLetterTitle: (state, payload) => {
        const { title } = payload;
        state.letterTitleParams = { mailId: state.letterId, title };
    },
    updateUploadAgainParams: (state, payload) => state.uploadAgainParams = payload,
    updateLetterTypeParams: (state, payload) => {
        state.letterTypeParams = {
            mailId: state.letterId,
            objectiveType: payload
        }
    },
}

import { GetMails, letterService, GetSelectContentListData, updateLetterContent, replyMailFileLimit, dubanDeptTree, listReminder, handOver, updateReply, entrust, updateObjectiveType, jiaobanDeptTree, zhuanbanDeptTree, updateLetterTitleName } from '@/api/allactions';
import { Message } from 'element-ui';
import baseUrl from '@/libs/util.src';

export default {
    namespaced: true,
    state,
    actions,
    mutations
}
